import React, { useState } from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

import logo from '../images/logo.png'
import '../styles/navbar.css'

const Navbar = ({ path }) => {
  const [responsiveClass, setResponsiveClass] = useState('')
  const [openSubmenu, setOpenSubmenu] = useState(null)
  const navBarActiveClass = 'active'

  function toggleHamburger() {
    if (responsiveClass === '') {
      setResponsiveClass('responsive')
    } else {
      setResponsiveClass('')
    }
  }

  const toggleSubmenu = key => setOpenSubmenu(prev => (prev === key ? null : key))

  return (
    <nav className={`${responsiveClass} `} role="navigation" aria-label="main-navigation">
      <div className="Nav container-full">
        <div className="Nav-logo">
          <Link to="/" title="Logo" className="logo-link">
            <img src={logo} alt="logo" style={{ width: '120px' }} />
          </Link>
          {/* Hamburger menu */}
          <div
            className={`burgerbars ${navBarActiveClass}`}
            data-target="navMenu"
            onClick={() => toggleHamburger()}
            aria-label="Toggle navigation"
            aria-expanded="false"
            role="button"
            tabIndex={0}
          >
            <span />
          </div>
        </div>
        <div className="Nav-links">
          <div className={`Link-container ${openSubmenu === 'about' ? 'expanded' : ''}`}>
            <div
              className="btn-open-sublink"
              onClick={() => toggleSubmenu('about')}
              role="button"
              tabIndex={0}
              aria-label="Toggle About submenu"
              aria-expanded={openSubmenu === 'about'}
            />

            <div className={`Nav-item Nav-subitems ${path && path.includes('/about') && 'active'}`}>
              <div className="Nav-item-text">About</div>
            </div>

            <ul className="Nav-sublinks">
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/about/our-beliefs">Our Beliefs</Link>
              </li>
              <li>
                <Link to="/about/mi-standards">MI Standards</Link>
              </li>
              <li>
                <Link to="/about/leadership">Leadership Team</Link>
              </li>
              <li>
                <Link to="/about/our-team">Staff Team</Link>
              </li>
              <li>
                <Link to="/about/states-territories">States and Territories</Link>
              </li>
              <li>
                <Link to="/about/ourpartners">Our Partners</Link>
              </li>
            </ul>
          </div>

          <div className={`Link-container ${openSubmenu === 'membership' ? 'expanded' : ''}`}>
            <div
              className="btn-open-sublink"
              onClick={() => toggleSubmenu('membership')}
              role="button"
              tabIndex={0}
              aria-label="Toggle Membership submenu"
              aria-expanded={openSubmenu === 'membership'}
            />

            <div
              className={`Nav-item Nav-subitems ${
                path && path.includes('/membership') && 'active'
              }`}
            >
              <div className="Nav-item-text">Membership</div>
            </div>

            <ul className="Nav-sublinks">
              <li>
                <Link to="/membership/mi-members-and-associates">Members and Associates</Link>
              </li>
              <li>
                <Link to="/membership/benefits">Member Benefits</Link>
              </li>
              <li>
                <Link to="/membership/join">Join MI</Link>
              </li>
              <li>
                <Link to="/membership/fees">Fees</Link>
              </li>
              <li>
                <Link to="/membership/croydon">Croydon Declaration</Link>
              </li>
            </ul>
          </div>

          <div className={`Link-container ${openSubmenu === 'get-involved' ? 'expanded' : ''}`}>
            <div
              className="btn-open-sublink"
              onClick={() => toggleSubmenu('get-involved')}
              role="button"
              tabIndex={0}
              aria-label="Toggle Get involved submenu"
              aria-expanded={openSubmenu === 'get-involved'}
            />
            <div
              className={`Nav-item Nav-subitems ${
                path &&
                (path.includes('/mi-networks') ||
                  path.includes('/serve-on-mission') ||
                  path.includes('/give-to-mission') ||
                  path.includes('/prayer-for-mission')) &&
                'active'
              }`}
            >
              <div className="Nav-item-text">Get involved</div>
            </div>

            <ul className="Nav-sublinks">
              <li>
                <Link to="/mi-networks">MI Networks</Link>
              </li>
              <li>
                <Link to="/serve-on-mission">Serve on Mission</Link>
              </li>
              <li>
                <Link to="/give-to-mission">Give to Mission</Link>
              </li>
              <li>
                <Link to="/prayer-for-mission">Prayer for Mission</Link>
              </li>
            </ul>
          </div>

          <div className={`Link-container ${openSubmenu === 'events' ? 'expanded' : ''}`}>
            <div
              className="btn-open-sublink"
              onClick={() => toggleSubmenu('events')}
              role="button"
              tabIndex={0}
              aria-label="Toggle Events submenu"
              aria-expanded={openSubmenu === 'events'}
            />

            <div
              className={`Nav-item Nav-subitems ${path && path.includes('/events') && 'active'}`}
            >
              <div className="Nav-item-text">Events</div>
            </div>

            <ul className="Nav-sublinks">
              <li>
                <Link to="/events">Events</Link>
              </li>
              <li>
                <Link to="/events/training">Training</Link>
              </li>
            </ul>
          </div>

          <div className={`Link-container ${openSubmenu === 'resources' ? 'expanded' : ''}`}>
            <div
              className="btn-open-sublink"
              onClick={() => toggleSubmenu('resources')}
              role="button"
              tabIndex={0}
              aria-label="Toggle Resources submenu"
              aria-expanded={openSubmenu === 'resources'}
            />

            <div
              className={`Nav-item Nav-subitems ${path && path.includes('/resources') && 'active'}`}
            >
              <div className="Nav-item-text">Resources</div>
            </div>
            <ul className="Nav-sublinks">
              <li>
                <Link to="/resources">Open Resources</Link>
              </li>
              <li>
                <Link to="/resources/helping-professionals">Helping Professionals</Link>
              </li>
              <li>
                <Link to="/resources/store">Resource Store</Link>
              </li>
              <li>
                <Link to="/member-only-resources">Member-Only Resources</Link>
              </li>
            </ul>
          </div>

          <div className="Link-container">
            <Link className="Nav-item Nav-subitems" to="/contact" activeClassName="active">
              <div className="Nav-item-text">Contact Us</div>
            </Link>
          </div>

          <div className="Link-container menu-nav-login">
            <Link to="/donate">
              <div className="Nav-item-text">Donate</div>
            </Link>
          </div>
        </div>

        <div
          className="nav-icon"
          onClick={toggleHamburger}
          role="button"
          tabIndex={0}
          aria-label="Toggle navigation"
        >
          <div />
        </div>

        <div className="Nav-login">
          <Link to="/donate">
            <div className="btn btn-call-to-action btn-secondary">Donate</div>
          </Link>
        </div>
      </div>
    </nav>
  )
}

Navbar.propTypes = {
  path: PropTypes.string
}

Navbar.defaultProps = {
  path: ''
}

export default Navbar
